import { Command } from 'commander'
import { createClient } from '../../client.js'
import { resolveWorkspace } from '../../lib/workspace-resolver.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printTable } from '../../output.js'

export const projectsListCommand = new Command(`list`)
  .description(`List projects in a workspace`)
  .option(`--workspace <id>`, `Workspace ID`)
  .action(async (opts) => {
    const json = projectsListCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const workspaceId = await resolveWorkspace(client, opts.workspace)
      const result = await client.projects.list({ workspaceId })

      if (isQuiet()) {
        for (const p of result.projects) {
          printQuiet(p.id)
        }
        return
      }

      if (json) {
        printJson(result)
      } else {
        printTable(
          [`ID`, `Name`, `Created`],
          result.projects.map((p) => [p.id, p.name, p.createdAt.slice(0, 10)])
        )
      }
    } catch (error) {
      handleError(error, json)
    }
  })
